class HHFastShipStatus extends HTMLElement {
  connectedCallback() {
    if (!this.dataset.sectionId) {
      this.dataset.sectionId = this.closest('[id^="shopify-section-"]')?.id.replace('shopify-section-', '') || '';
    }

    if (this.dataset.relocated !== 'true') {
      queueMicrotask(() => this.relocate());
    }

    this.startWatching();
  }

  disconnectedCallback() {
    document.removeEventListener('click', this._onFormClick);
  }

  relocate() {
    if (this.dataset.relocated === 'true' || !this.isConnected) return;

    const target =
      document.querySelector('[data-product-upgrades]') ||
      document.querySelector('.product-form-buttons') ||
      document.querySelector('form[data-type="add-to-cart-form"]') ||
      document.querySelector('.st_pi-form');

    if (target && target.parentNode) {
      this.dataset.relocated = 'true';
      target.parentNode.insertBefore(this, target);
    }
  }

  /**
   * Sternify's own pill-style variant picker never dispatches the theme's
   * native variant:update event, lives outside .st_pi-form entirely, and
   * replaces the id input's DOM node on its own re-renders. Polling the id
   * input's value after each click sidesteps all of that.
   *
   * Note: the public /products/{handle}.js endpoint deliberately doesn't
   * expose real inventory counts (Shopify hides that from storefront JSON) -
   * it only has an `available` boolean, which is true for both real stock
   * AND build-to-order (continue-selling) variants, so it can't tell them
   * apart. Re-rendering via the Section Rendering API instead asks the
   * server to redo the same Liquid computation this section already does on
   * first load, with the real per-variant inventory data Liquid has access
   * to - the client just swaps in the resulting markup. The section id is
   * captured here (before relocate() moves this element into the buy-form's
   * own section subtree) rather than looked up fresh later, since after the
   * move closest('[id^="shopify-section-"]') would resolve to the WRONG
   * (buy-form's) section.
   */
  getIdInput() {
    return (
      document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]') ||
      document.querySelector('.st_pi-form input[name="id"]')
    );
  }

  startWatching() {
    this._onFormClick = () => {
      const idAtClickTime = this.getIdInput()?.value;
      this.pollForChange(idAtClickTime, 0);
    };
    document.addEventListener('click', this._onFormClick);
  }

  pollForChange(previousId, attempts) {
    if (attempts > 20) return;

    setTimeout(() => {
      const currentId = this.getIdInput()?.value;
      if (currentId && currentId !== previousId) {
        this.fetchAndRender(currentId);
      } else {
        this.pollForChange(previousId, attempts + 1);
      }
    }, 100);
  }

  async fetchAndRender(variantId) {
    const sectionId = this.dataset.sectionId;
    if (!sectionId) return;

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    url.searchParams.set('section_id', sectionId);

    try {
      const html = await fetch(url).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('hh-fast-ship-status');
      if (fresh) this.innerHTML = fresh.innerHTML;
    } catch (err) {
      console.error('[hh-fast-ship-status]', err);
    }
  }
}

if (!customElements.get('hh-fast-ship-status')) {
  customElements.define('hh-fast-ship-status', HHFastShipStatus);
}
